import React, {useEffect, useState} from "react";
import EnigooButton from "../../../MyComponent/EnigooButton";
import {FiCalendar, FiPlus, FiPrinter, FiSend, FiUserPlus, FiUsers} from "react-icons/fi";
import Widget from "../../../components/widget";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import EnigooBreadcrumbs from "../../../MyComponent/EnigooBreadcrumbs";
import Dropdown from "../../../components/dropdowns/dropdown-1";
import {userPrint} from "./CollectiveOperations/UserPrint";
import CogoToast from "cogo-toast";
import {SendMailModal} from "../EmailQueue/SendMailModal";
import VerifyRights from "../../VerifyRights";
import {AssignUserToGroupModal} from "./CollectiveOperations/AssignUserToGroupModal";
import {AiOutlineFileExcel, AiOutlineFilePdf, FiImage} from "react-icons/all";
import {CopyUserToActionModal} from "./CollectiveOperations/CopyUserToActionModal";
import UserTable from "./UserTable";
import {UserPrintErrorModal} from "./CollectiveOperations/UserPrintErrorModal";
import {userExport} from "./UserExport";
import {useTranslation} from "react-i18next";
import UserAssignDaysModal from "./CollectiveOperations/UserAssignDaysModal";
import UserAssignZoneModal from "./CollectiveOperations/UserAssignZoneModal";
import {useHistory} from "react-router-dom";
import ImageExportModal from "./ImageExportModal";
import UserFilterForm from "./Filter/UserFilterForm";
import {apiGetActionById} from "../Action/Actions";
import {UserExportModal} from "./UserExportModal";


const User = () => {
    let [printing, setPrinting] = useState(false);
    let [selectedRows, setSelectedRows] = useState([]);
    let [openModal, setOpenModal] = useState(false);
    let [filtering, setFiltering] = useState(false);
    let [printError, setPrintError] = useState(null);
    let [openGroupModal, setOpenGroupModal] = useState(false);
    let [openActionModal, setOpenActionModal] = useState(false);
    let [selectAll, setSelectAll] = useState(false);
    let [userExportModal, setUserExportModal] = useState(false);

    const {t} = useTranslation()
    const history = useHistory();
    const dispatch = useDispatch();

    const {actualAction} = useSelector(
        state => ({customField: state.reducerAdmin.customField, actualAction: state.reducerAdmin.actualAction}),
        shallowEqual
    )
    const {filterUser} = useSelector(
        state => ({
            filterUser: state.reducerAdmin.filterUser
        }),
        shallowEqual
    )

    const {openFilter, filtered, filterData} = filterUser;

    useEffect(() => {
        if ((!filterData || !filterData.entranceDate)) {
            let date = new Date().toISOString();
            date = date.slice(0, date.indexOf("T"));
            dispatch({
                type: 'SET_FILTER_DATA',
                filterData: {
                    entranceDate: date
                }
            })

        }
        actualAction.actualAction && apiGetActionById(actualAction.actualAction, (data) => {
            dispatch({
                type: 'LOAD_DATA_ACTUAL_ACTION',
                customField: data.customField
            })
        }, (err) => {
            console.log(err)
        })
    }, []);


    useEffect(() => {
        const handleKeyDown = (event) => {
            if ((event.ctrlKey || event.metaKey) && event.key === 'p') {
                event.preventDefault();
                if (filtered && selectAll) {
                    userPrint(selectedRows, setPrinting, actualAction, setPrintError, "print", filterData, selectAll, t("accreditation.errorNoData"), t("accreditation.errorPrint"), t("accreditation.errorExport"));
                } else if (selectAll) {
                    userPrint(selectedRows, setPrinting, actualAction, setPrintError, "print", null, true, t("accreditation.errorNoData"), t("accreditation.errorPrint"), t("accreditation.errorExport"));
                } else {
                    userPrint(selectedRows, setPrinting, actualAction, setPrintError, "print", null, selectAll, t("accreditation.errorNoData"), t("accreditation.errorPrint"), t("accreditation.errorExport"));
                }
                console.log('Ctrl/Command + P was pressed');
            }
            if ((event.ctrlKey || event.metaKey) && event.key === 'a') {
                event.preventDefault();
                setSelectAll(!selectAll);
                console.log('Ctrl/Command + A was pressed');
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [selectedRows, selectAll]);

    const _renderBody = () => {
        return <UserTable selectedRows={selectedRows} setSelectedRows={setSelectedRows} selectedRowsAll={selectAll}
                          setSelectedRowsAll={setSelectAll} filtering={filtering} setFiltering={setFiltering}/>
    }

    const getPlatformShortCut = (letter) => {
        const platform = navigator.userAgent.toLowerCase();
        if (platform.includes("mac")) {
            return ("(⌘Cmd + " + letter.toUpperCase() + ")");
        } else {
            return ("(Ctrl + " + letter.toUpperCase() + ")");
        }
    }

    const filter = (filterValues) => {
        let values = filterValues;
        let array = [];
        actualAction.customField.map((item, index) => {
            if ((values[`cf-${item.id}`] !== undefined && values[`cf-${item.id}`] !== null)) {
                if (item.customFieldType.type === "BOOL" || item.customFieldType.type === "IMAGE") {
                    if (values[`cf-${item.id}`] === 'true') {
                        array.push({
                            "id": item.id,
                            "value": true
                        })
                    }
                    if (values[`cf-${item.id}`] === 'false') {
                        array.push({
                            "id": item.id,
                            "value": false
                        })
                    }
                } else {
                    array.push({
                        "id": item.id,
                        "value": values[`cf-${item.id}`]
                    });
                }
            }
        })
        if (values.printed && values.printed === -1) {
            values.wasPrint = false;
        } else if (values.printed && values.printed === 1) {
            values.wasPrint = true;
        } else {
            values.wasPrint = undefined;
        }
        values.customField = array;
        values.actionId = actualAction.actualAction;
        if (filtered === true) {
            dispatch({
                type: 'SET_FILTERED',
                filtered: false
            })
        }
        dispatch({
            type: 'SET_FILTERED',
            filtered: true
        })
        dispatch({
            type: 'SET_FILTER_DATA',
            filterData: values
        })
        dispatch({
            type: 'CHANGE_PAGE_INDEX',
            pageIndex: 0,
        })
    }

    const onExport = (imageTypeExport) => {
        if (filtered && selectAll) {
            userExport(selectedRows, setPrinting, actualAction, setPrintError, filterData, selectAll, t("accreditation.errorNoData"), t("accreditation.errorPrint"), t("accreditation.errorExport"), imageTypeExport);
            setUserExportModal(false)
        } else if (selectAll) {
            userExport(selectedRows, setPrinting, actualAction, setPrintError, null, selectAll, t("accreditation.errorNoData"), t("accreditation.errorPrint"), t("accreditation.errorExport"), imageTypeExport);
            setUserExportModal(false)
        } else {
            userExport(selectedRows, setPrinting, actualAction, setPrintError, null, selectAll, t("accreditation.errorNoData"), t("accreditation.errorPrint"), t("accreditation.errorExport"), imageTypeExport);
            setUserExportModal(false)
        }
    }

    const _renderFilterForm = () => {
        return <UserFilterForm filter={filter} filtering={filtering}/>
    }

    const _renderButtons = () => (
        <div className={"flex flex-row"}>
            <VerifyRights page={["user", "emailQueue", "userImport", "user"]}
                          action={["filterUser", "sendMail", "importUser", "getUserPrintData"]}>
                <div className="mr-1">
                    <Dropdown
                        width="w-64"
                        placement={`bottom-end`}
                        disabled={printing}
                        title={printing ? t("loading.working") :
                            <span className={"uppercase"}>{t("basics.options")}</span>}>
                        <>
                            <div className="flex flex-col text-center">
                                <VerifyRights page={"emailQueue"} action={"sendMail"}>
                                    <div
                                        className="items-center flex flex-wrap justify-center h-8 space-y-1 dropdown-item">
                                        <button disabled={(!selectedRows || selectedRows.length < 1) && !selectAll}
                                                onClick={() => {
                                                    if ((!selectedRows || selectedRows.length < 1) && selectAll === false) {
                                                        CogoToast.error(t("accreditation.chooseUserToSendMail"));
                                                    } else {
                                                        setOpenModal(true);
                                                    }
                                                }}
                                                className="btn text-xs btn-icon w-full btn-rounded h-full hover:bg-enigoo-500 hover:text-white">
                                            <FiSend className={"mr-2"}/>{t("accreditation.sendMail")}
                                        </button>
                                    </div>
                                </VerifyRights>
                                <VerifyRights page={"userImport"} action={"importUser"}>
                                    <div
                                        className="items-center flex flex-wrap justify-center h-8 space-y-1 dropdown-item">

                                        <button onClick={() => history.push("/accreditation/import")}
                                                className="btn text-xs btn-icon w-full btn-rounded h-full hover:bg-enigoo-500 hover:text-white">
                                            <FiUserPlus className={"mr-2"}/> {t("basics.import")}
                                        </button>
                                    </div>
                                </VerifyRights>
                                <VerifyRights page={"user"} action={"getUserPrintData"}>
                                    <div
                                        className="items-center flex flex-wrap justify-center h-8 space-y-1 dropdown-item">
                                        <button disabled={(!selectedRows || selectedRows.length < 1) && !selectAll}
                                                onClick={() => {
                                                    if (filtered && selectAll) {
                                                        userPrint(selectedRows, setPrinting, actualAction, setPrintError, "print", filterData, selectAll, t("accreditation.errorNoData"), t("accreditation.errorPrint"), t("accreditation.errorExport"));
                                                    } else if (selectAll) {
                                                        userPrint(selectedRows, setPrinting, actualAction, setPrintError, "print", null, true, t("accreditation.errorNoData"), t("accreditation.errorPrint"), t("accreditation.errorExport"));
                                                    } else {
                                                        userPrint(selectedRows, setPrinting, actualAction, setPrintError, "print", null, selectAll, t("accreditation.errorNoData"), t("accreditation.errorPrint"), t("accreditation.errorExport"));
                                                    }

                                                }}
                                                className="btn text-xs btn-icon w-full btn-rounded h-full hover:bg-enigoo-500 hover:text-white">
                                            <FiPrinter
                                                className={"mr-2"}/> {printing ? t("loading.working") : (t("basics.print") + " " + getPlatformShortCut("p"))}
                                        </button>
                                    </div>
                                </VerifyRights>
                                <VerifyRights page={"user"} action={"exportUser"}>
                                    <>
                                        <div
                                            className="items-center flex flex-wrap justify-center h-8 space-y-1 dropdown-item">
                                            <button disabled={(!selectedRows || selectedRows.length < 1) && !selectAll}
                                                    onClick={() => {
                                                        userPrint(selectedRows, setPrinting, actualAction, setPrintError, "export", filtered && selectAll ? filterData : null, selectAll, t("accreditation.errorNoData"), t("accreditation.errorPrint"), t("accreditation.errorExport"));
                                                    }}
                                                    className="btn text-xs btn-icon w-full btn-rounded h-full hover:bg-enigoo-500 hover:text-white">
                                                <AiOutlineFilePdf
                                                    className={"mr-2"}/> {printing ? t("loading.working") : t("accreditation.generatePdf")}
                                            </button>

                                        </div>
                                        <UserExportModal setOpen={setUserExportModal} open={userExportModal} onSave={onExport}/>
                                    </>
                                </VerifyRights>
                                <VerifyRights page={"user"} action={"exportUser"}>
                                    <div
                                        className="items-center flex flex-wrap justify-center h-8 space-y-1 dropdown-item">
                                        <button disabled={(!selectedRows || selectedRows.length < 1) && !selectAll}
                                                onClick={() => {
                                                    setUserExportModal(true);

                                                }}
                                                className="btn text-xs btn-icon w-full btn-rounded h-full hover:bg-enigoo-500 hover:text-white">
                                            <AiOutlineFileExcel
                                                className={"mr-2"}/> {printing ? t("basics.working") : t("basics.export")}
                                        </button>
                                    </div>
                                </VerifyRights>
                                <VerifyRights page={"user"} action={"exportUser"}>
                                    <ImageExportModal selectedRows={selectedRows}
                                                      actionId={actualAction.actualAction} selectAll={selectAll}/>
                                </VerifyRights>
                                <VerifyRights page={"user"} action={"assignUserToGroups"}>
                                    <div
                                        className="items-center flex flex-wrap justify-center h-8 space-y-1 dropdown-item">
                                        <button disabled={(!selectedRows || selectedRows.length < 1) && !selectAll}
                                                onClick={() => {
                                                    if ((!selectedRows || selectedRows.length < 1) && !selectAll) {
                                                        CogoToast.error(t("accreditation.chooseUserToAssignGroup"));
                                                    } else {
                                                        setOpenGroupModal(true);
                                                    }
                                                }}
                                                className="btn text-xs btn-icon w-full btn-rounded h-full hover:bg-enigoo-500 hover:text-white">
                                            <FiUsers className={"mr-2"}/>{t("accreditation.assignGroup")}
                                        </button>
                                    </div>
                                </VerifyRights>
                                <VerifyRights page={"user"} action={"copyUserToAction"}>
                                    <div
                                        className="items-center flex flex-wrap justify-center h-8 space-y-1 dropdown-item">
                                        <button disabled={(!selectedRows || selectedRows.length < 1) && !selectAll}
                                                onClick={() => {
                                                    if ((!selectedRows || selectedRows.length < 1) && !selectAll) {
                                                        CogoToast.error(t("accreditation.chooseUserToDuplicateToAction"));
                                                    } else {
                                                        setOpenActionModal(true);
                                                    }
                                                }}
                                                className="btn text-xs btn-icon w-full btn-rounded h-full hover:bg-enigoo-500 hover:text-white">
                                            <FiCalendar className={"mr-2"}/> {t("accreditation.duplicateToAction")}
                                        </button>
                                    </div>
                                </VerifyRights>

                                <VerifyRights page={"user"} action={"assignDays"}>
                                    <UserAssignDaysModal selectedRows={selectedRows}
                                                         actionId={actualAction.actualAction} selectAll={selectAll}/>
                                </VerifyRights>
                                <VerifyRights page={"user"} action={"assignZone "}>
                                    <UserAssignZoneModal selectedRows={selectedRows}
                                                         actionId={actualAction.actualAction} selectAll={selectAll}/>
                                </VerifyRights>
                            </div>
                        </>
                    </Dropdown>
                </div>
            </VerifyRights>
            <VerifyRights page={"user"} action={"createUser"}>
                <div>
                    <EnigooButton
                        link={"/accreditation/create"} icon={<FiPlus/>}
                        text={t("basics.add")}/>
                </div>
            </VerifyRights>
        </div>
    )


    return (
        <>
            <CopyUserToActionModal selectedIds={selectedRows} open={openActionModal} setOpen={setOpenActionModal}
                                   selectAll={selectAll}/>
            <SendMailModal selectedIds={selectedRows} open={openModal} setOpen={setOpenModal} selectAll={selectAll}/>
            <AssignUserToGroupModal setOpen={setOpenGroupModal} open={openGroupModal} selectedIds={selectedRows}
                                    selectAll={selectAll}/>
            <UserPrintErrorModal error={printError} setError={setPrintError}/>
            <EnigooBreadcrumbs right={_renderButtons()}/>
            <Widget>
                {_renderFilterForm()}
            </Widget>
            <Widget>
                {_renderBody()}
            </Widget>
        </>
    )
}

export default User;
